<template>
  <div id="chat">
    <div id="webchat-container"></div>
  </div>
</template>

<script>
export default {
  name: 'chat',
  props: {
    email: {
      type: String,
      required: true
    },
    firstname: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      styleInterval: null,
      userUpdateTimer: null
    }
  },
  methods: {
    initializeBotpress() {
      const checkBotpress = setInterval(() => {
        if (window.botpress) {
          clearInterval(checkBotpress)

          // Give Botpress time to initialize
          setTimeout(() => {
            this.setupBot()
          }, 1000)
        }
      }, 100)
    },

    setupBot() {
      // First apply styles and open chat
      this.injectStyles()
      window.botpress.open()

      // Start watching for iframe
      this.startWatchingIframe()

      // Start delayed user update attempts
      setTimeout(() => {
        this.updateUserData()
      }, 2000)
    },

    updateUserData() {
      // Function to try the update
      const tryUpdate = () => {
        try {
          window.botpress.updateUser({
            userId: `${this.email}`,
            data: {
              email: this.email,
              firstname: this.firstname
            }
          })

          // Try one more time after a delay to ensure it sticks
          setTimeout(() => {
            window.botpress.updateUser({
              userId: `${this.email}`,
              data: {
                email: this.email,
                firstname: this.firstname
              }
            })
          }, 1000)
        } catch (error) {
          console.error('Failed to update user:', error)
        }
      }

      // Try multiple times with increasing delays
      tryUpdate()
      setTimeout(tryUpdate, 2000)
      setTimeout(tryUpdate, 4000)
      setTimeout(tryUpdate, 6000)
    },

    injectStyles() {
      const styleId = 'botpress-fullscreen-styles'
      let styleTag = document.getElementById(styleId)

      if (!styleTag) {
        styleTag = document.createElement('style')
        styleTag.id = styleId
        styleTag.innerHTML = `
          #bp-web-widget,
          #bp-web-widget iframe,
          .bpWebchat,
          .bpWebchat iframe,
          [class*="webchat"] {
            max-height: 100vh !important;
            width: 100% !important;
            height: 100% !important;
            inset: 0 !important;
            position: fixed !important;
            border: none !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
            z-index: 9999 !important;
          }
        `
        document.head.appendChild(styleTag)
      }
    },

    startWatchingIframe() {
      if (this.styleInterval) {
        clearInterval(this.styleInterval)
      }

      let attempts = 0
      this.styleInterval = setInterval(() => {
        const iframe = document.querySelector('#bp-web-widget iframe')
        if (iframe) {
          this.applyStylesToElement(iframe)
          if (iframe.parentElement) {
            this.applyStylesToElement(iframe.parentElement)
          }
        }

        attempts++
        if (attempts >= 10) {
          clearInterval(this.styleInterval)
        }
      }, 1000)
    },

    applyStylesToElement(element) {
      const styles = {
        'max-height': '100vh',
        'width': '100%',
        'height': '100%',
        'inset': '0',
        'position': 'fixed',
        'z-index': '9999'
      }

      Object.entries(styles).forEach(([key, value]) => {
        element.style.setProperty(key, value, 'important')
      })
    }
  },
  mounted() {
    let scriptsLoaded = 0
    const totalScripts = 2

    const onScriptLoad = () => {
      scriptsLoaded++
      if (scriptsLoaded === totalScripts) {
        this.initializeBotpress()
      }
    }

    // Load Botpress inject script
    const injectScript = document.createElement('script')
    injectScript.src = 'https://cdn.botpress.cloud/webchat/v2.2/inject.js'
    injectScript.async = true
    injectScript.onload = onScriptLoad
    document.body.appendChild(injectScript)

    // Load custom configuration script
    const configScript = document.createElement('script')
    configScript.src = 'https://files.bpcontent.cloud/2024/11/17/17/20241117173425-T8UGK8BP.js'
    configScript.async = true
    configScript.onload = onScriptLoad
    document.body.appendChild(configScript)
  },
  beforeDestroy() {
    if (this.styleInterval) {
      clearInterval(this.styleInterval)
    }
    if (this.userUpdateTimer) {
      clearTimeout(this.userUpdateTimer)
    }
  }
}
</script>

<style lang="css" scoped>
#chat {
  background: #fff;
}
</style>